// extracted by mini-css-extract-plugin
export default {"main_page":"ToyotaFortuner_main_page__Pke6H","car_image":"ToyotaFortuner_car_image__mXVbJ"};